import { StateInterface } from "./state";
import { OrganisationModel } from "modules/relationprofile/models";
import { PrivatePersonModel } from "../models/privatePerson";
import { FileEntryModel } from "../models/fileEntry";

export default {
  setCurrentOrganisation(
    state: StateInterface,
    organisation: OrganisationModel
  ): void {
    state.organisation = organisation;
  },
  setCurrentPrivatePerson(
    state: StateInterface,
    person: PrivatePersonModel
  ): void {
    state.privatePerson = person;
  },
  setFileEntriesForProject(
    state: StateInterface,
    entries: FileEntryModel[]
  ): void {
    if (entries.length > 0) state.fileEntries = entries;
  }
};
